import React from 'react';
import { Route, Routes } from 'react-router-dom';

import SDK from './pages/SDK';
import Home from './pages/Home';
import Selfie from './pages/Selfie';
import FrontDoc from './pages/FrontDocument';
import BackDoc from './pages/BackDocument';
import Success from './pages/Success';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Routes>
      <Route path='/' element={<Home />} index={true} caseSensitive={false} />
      <Route path='/selfie' element={<Selfie />} />
      <Route path='/sdk' element={<SDK />} />
      <Route path='/front-doc' element={<FrontDoc />}/>
      <Route path='/back-doc' element={<BackDoc />}/>
      <Route path='/success' element={<Success />}/>
      <Route path='*' element={<NotFound />}/>
    </Routes>
  )

}

export default App;
